import {useSelector} from 'react-redux'

const usePayments = () => useSelector( state => {
	const isClient = state.users.current_user?.account_type === 'client'
	const enabled = (
		!isClient ?
		(
			state.users.current_user?.stripe_account?.enabled === 1 ||
			!Boolean(state.users.current_user?.stripe_account)
		) :
		true
	)
	const customerPaymentId = state.users.current_user?.customer_payment_id
	const isSetup = (Boolean(state.users.current_user?.stripe_account?.stripe_user_id)||isClient)

	return {enabled,customerPaymentId,isSetup}
})

export default usePayments